import dayjs from 'dayjs';

const FORMAT_PATTERN = 'MMM D, YYYY h:mm A';

export function formatDate(date: Date | number | undefined): string {
  if (!date) return 'N/A';
  return dayjs(date).format(FORMAT_PATTERN);
}
